import waitUntil from 'async-wait-until';
import { closest, removeNode } from '@utils/domUtils';
import { post, request } from '@utils/request';

import '../../../vendor/plugins/jquery.serializeJSON';

/* global jQuery, ACTION_ROUTES */

export default class ApplicationDocumentsManager {
  static selectorString() {
    return '.ApplicationDocumentsManager';
  }

  async render(node, props) {
    this.fileUpload = node.querySelector('.FileUpload');
    this.documentsList = node.querySelector('.documents-list');
    this.isDeleting = false;

    await waitUntil(() => this.fileUpload.component);

    this.fileUpload.addEventListener('fileUploadComplete', this.fileUploaded.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    [...this.node.querySelectorAll('[data-action="deleteDocument"]')].forEach(element => {
      element.doc = closest(element, '.application-document');
      element.doc.documentId = element.doc.getAttribute('data-id');
      element.doc.applicationId = parseInt(element.doc.getAttribute('data-application-id'));
      element.addEventListener('click', this.deleteDocument.bind(this));
    });
  }

  refresh() {
    jQuery.get(window.location.href, response => {
      this.documentsList.innerHTML = jQuery(response)
        .find('.ApplicationDocumentsManager .documents-list')
        .html();
      this.bindEvents();
    });
  }

  removeUploadedItems(uploadedItems) {
    setTimeout(() => {
      uploadedItems.forEach(element => {
        removeNode(element);
      });

      this.fileUpload.component.updateFileList();
    }, 1000);
  }

  fileUploaded() {
    const form = closest(this.fileUpload, 'form');

    const uploadedItems = [...this.fileUpload.querySelectorAll('.dz-complete')];

    const data = jQuery(form).serializeJSON();

    if (!data.customDocuments) {
      return;
    }

    data.customDocuments.uploads = data.customDocuments.uploads.filter(
      value => value.toString().length > 0,
    );

    if (data.customDocuments.uploads.length === 0) {
      return;
    }

    request({
      url: form.getAttribute('action'),
      method: form.getAttribute('method') || 'POST',
      data: data,
      success: () => {
        this.refresh();
        this.removeUploadedItems(uploadedItems);
      },
    });
  }

  deleteDocument(event) {
    if (this.isDeleting) {
      return;
    }

    const doc = event.currentTarget.doc;

    if (doc) {
      this.isDeleting = true;

      post({
        url: ACTION_ROUTES.DELETE_APPLICATION_DOCUMENT,
        data: {
          applicationId: doc.applicationId,
          documentId: doc.documentId,
        },
        success: data => {
          this.isDeleting = false;
          this.refresh();
        },
        error: () => {
          this.isDeleting = false;
        },
      });
    }
  }
}
